import React from 'react';
import { FilterDropdown } from './FilterDropdown';
import { useTranslation } from 'react-i18next';

interface YearFilterDropdownProps {
  selectedYears: string[];
  onYearsChange: (years: string[]) => void;
  onApplyFilter: () => void;
  onClearFilter: () => void;
  isFilterApplied: boolean;
}

export const YearFilterDropdown: React.FC<YearFilterDropdownProps> = ({
  selectedYears,
  onYearsChange,
  onApplyFilter,
  onClearFilter,
  isFilterApplied,
}) => {
  const { t } = useTranslation();
  const availableYears = ['2026', '2025', '2024', '2023', '2022', '2021', '2020'];

  return (
    <FilterDropdown
      label={t('history.documents.filters.year')}
      selectedItems={selectedYears}
      availableItems={availableYears}
      onItemsChange={onYearsChange}
      onApplyFilter={onApplyFilter}
      onClearFilter={onClearFilter}
      isFilterApplied={isFilterApplied}
    />
  );
};
